import { TestRunStatus } from '../../models/test-run.model';

/** Aus diesen Status laesst sich ein Lauf von Hand abbrechen — `TestRunMutationGuard#requireNotFinal`. */
export const ABORTABLE_STATUSES: readonly TestRunStatus[] = ['DRAFT', 'READY', 'RUNNING', 'PAUSED'];

/**
 * Jede Absage des Abbruchs mit eigenem Satz (NEX-1315). Ein 409 meint hier nicht bloss
 * einen veralteten Stand: auch eine laufende Pipeline oder ein offener Runner-Auftrag
 * sperren den Abbruch. Runner und Testlauf-Uebersicht (NEX-1400) teilen sich die Zuordnung.
 */
export function abortErrorKeyFor(status: number): string {
  switch (status) {
    case 400:
      return 'testRunner.abortError.invalid';
    case 403:
      return 'testRunner.abortError.forbidden';
    case 409:
      return 'testRunner.abortError.conflict';
    default:
      return 'testRunner.abortError.generic';
  }
}
